import { render, staticRenderFns } from "./EffortsChart.vue?vue&type=template&id=72470ed4&scoped=true"
import script from "./EffortsChart.vue?vue&type=script&lang=js"
export * from "./EffortsChart.vue?vue&type=script&lang=js"
import style0 from "./EffortsChart.vue?vue&type=style&index=0&id=72470ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72470ed4",
  null
  
)

export default component.exports